import { Container, Title, Button } from '@/components'

import styles from './styles.module.scss'
import Image from 'next/image'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'
import screensImg from '/public/images/home-training-screens.webp'

const HomeTraining = ({
  description = 'Seja no Celular, Notebook ou SmarTV, na Academia Foguete você terá acesso a transmissão de treinos Ao Vivo 24 horas por dia, além de uma biblioteca imensa de treinos gravados para assistir quantas vezes quiser. Seja qual for seu objetivo ou tempo disponível, a Academia Foguete tem o treino perfeito para você.',
  smallDisclaimer = '',
  variant,
  buttonColor,
  buttonTextVariant,
  buttonText = 'QUERO EXPERIMENTAR'
}) => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  return (
    <section className={`fgt-section ${styles.homeTraining} ${styles[variant]} `}>
      <Container>
        <Title Tag="h2" alignText="center" colorText="light">
          FLEXIBILIDADE PARA <span>TREINAR</span> QUANDO E <span>ONDE QUISER</span>
        </Title>
        <p className="fgt-subtitle fgt-subtitle--light">{description}</p>

        <div className={styles.homeTraining__content}>
        {screensImg && (
            <Image
              src={screensImg}
              height={"auto"}
              width={"auto"}
              alt="Imagem de telas da academia foguete"
              className={styles.image}
            />
          )}
        </div>

        <p className={styles.smallDisclaimer}>{smallDisclaimer}</p>

        <div
          className={`${styles.button} fgt-section__action`}
        >
          <Button
            id="btn-section-homeTraining-types"
            variant={buttonColor || 'primary'}
            textVariant={buttonTextVariant}
            className={'fgt-section__action--button'}
            onClick={() => {
              onClickItem('comparePlans')
            }}
          >
            {buttonText}
          </Button>
        </div>
      </Container>
    </section>
  )
}

export default HomeTraining
